<template>
  <div :class="style.mainPage">
    <header>
      <img src="$images/logo.svg" />
      <button v-if="!modile" @click="$router.push('/user')">
        <img src="$images/entrance.svg" alt="" />
        <span>Вход</span>
      </button>
    </header>
    <section :class="style.brieflyReadds">
      <span :class="style.underHeader">Настоящая забота о пациентах</span>
      <h2>
        Readds — сервис<br />
        онлайн-записи<br />
        для клиник
      </h2>
      <p>
        Онлайн-запись стала комфортной и&nbspдоступной. Readds совместим
        с&nbspбольшинством МИС, настраивается в&nbspпару кликов и&nbspработает
        на&nbspвсех устройствах.
      </p>
      <ButtonSimple
        :text="'Подключить'"
        :styleText="{fontSize: '26px'}"
        @click="wayToСonnectionForm()"
      />
    </section>
    <section v-if="modile" :class="style.video + ' ' + style.mobile">
      <div :class="style.mainBlock">
        <video autoplay muted loop="true">
          <source src="$images/vi.mp4" type="video/mp4" />
        </video>
        <div :class="style.infoMobile">
          <p>
            Пациенты смогут<br />
            записаться на приём<br />
            с вашего сайта
          </p>
          <span :class="style.underHeader">
            Readds интегрируется с любым<br />
            сайтом в несколько кликов
          </span>
        </div>
      </div>
    </section>
    <section v-else :class="style.video">
      <div :class="style.mainBlock">
        <video
          style="-o-object-fit: cover; object-fit: cover"
          playsinline
          autoplay
          loop
          muted
        >
          <source src="$images/vi.mp4" type="video/mp4" />
        </video>
        <div :class="style.infoMobile">
          <p>
            Пациенты смогут<br />
            записаться на приём<br />
            с вашего сайта
          </p>
          <span :class="style.underHeader">
            Readds интегрируется с любым<br />
            сайтом в несколько кликов
          </span>
        </div>
      </div>
    </section>
    <div :class="style.separation" />
    <section :class="style.mobile">
      <div :class="style.mainBlock">
        <img src="$images/mobile.jpg" alt="" />
        <div :class="style.infoMobile">
          <p>Работает на всех<br />устройствах</p>
          <span :class="style.underHeader"
            >90% пользваотелей заходит на ваш сайт через мобильный телефон</span
          >
        </div>
      </div>
    </section>
    <div :class="style.separation" />
    <section :class="style.connection">
      <h2>
        Поможем подключить<br />
        и настроить
      </h2>
      <p>
        Онлайн-запись стала комфортной и доступной. Readds<br />
        совместим с большинством МИС, настраивается в пару кликов<br />
        и работает на всех устройствах.
      </p>
      <ButtonSimple
        :text="'Подключить'"
        :styleText="{fontSize: '26px'}"
        @click="wayToСonnectionForm()"
      />
    </section>
    <div :class="style.separation" />
    <section :class="style.LkDisplay">
      <div :class="style.mainBlock">
        <img src="$images/lk.png" alt="" />
        <div :class="style.LkInfo">
          <p>Удобная настройка<br />и управление</p>
          <span :class="style.underHeader"
            >Readds интегрируется с любым<br />сайтом в несколько кликов</span
          >
        </div>
      </div>
    </section>
    <div :class="style.separation" />
    <section :class="style.notifications">
      <h2>Уведомление о записях</h2>
      <p>
        После того как пользователь запишется на приём, вы получите<br />
        уведомление. Уведомление можно получать на почту, в Телеграм,<br />
        МИС и CRM
      </p>
      <ButtonSimple
        :text="'Подключить'"
        :styleText="{fontSize: '26px'}"
        @click="wayToСonnectionForm()"
      />
    </section>
    <div :class="style.separation" />
    <section :class="style.tariff">
      <h2>Тарифы</h2>
      <p>
        Readds находится в бета тестирование, сейчас доступен 1 тариф,<br />
        без ограничений на количесвто сайтов и врачей.
      </p>
      <div :class="style.tariffList">
        <div :class="style.tariffItem" v-for="data in tariffList">
          <div v-if="!data.status" :class="style.availability">
            <span :class="style.underHeader"></span>
            <img :src="eye" alt="" />
            <span :class="style.underHeader">Этот тариф пока не доступен</span>
          </div>
          <article :class="style.header">
            <h3 :class="style.name" v-text="data.name" />
            <span
              :class="[style.description, style.underHeader]"
              v-text="data.description"
            />
          </article>
          <h3 v-text="data.cost + ' ₽ в мес'" />
          <ul>
            <li v-for="dignity in data.dignities" v-text="'— ' + dignity" />
          </ul>
          <ButtonSimple
            :text="'Подключить'"
            :styleButton="{margin: 0}"
            :styleText="{fontSize: '16px'}"
            v-if="data.status"
            @click="wayToСonnectionForm()"
          />
        </div>
      </div>
    </section>
    <section id="connectionForm" :class="style.connectionForm">
      <div :class="style.mainBlock">
        <h2 v-if="statusSendForm != true">Оставить заявку</h2>
        <h2 v-else>Заявка отправлена</h2>
        <p v-if="statusSendForm != true">
          Заполните форму ниже, мы свяжемся с вами, проведём демонстрацию и
          поможем подключить сервис онлайн-записи
        </p>
        <p v-else>
          Мы получили вашу заявку и свяжемся с вами в&nbsp;ближайшее время
        </p>
        <form v-if="statusSendForm != true">
          <input
            v-model="form.name"
            placeholder="Введите ваше имя"
            type="text"
            id="name"
          />
          <label for="name">Введите ваше имя</label>
          <input
            v-model="form.city"
            placeholder="Введите ваш город"
            type="text"
            id="city"
          />
          <label for="city">Введите ваш город</label>
          <input
            v-model="form.clinic"
            placeholder="Введите напрвление клиники"
            type="text"
            id="clinic"
          />
          <label for="clinic">Введите напрвление клиники</label>
          <input
            v-model="form.phone"
            v-imask="{mask: '{+7} 000 000-00-00'}"
            @input="setPhone($event)"
            placeholder="+7 999 999-99-99"
            type="text"
            id="phone"
          />
          <label for="phone">+7 999 999-99-99</label>
          <ErrorBlock
            style="flex-direction: row; justify-content: start"
            v-if="statusSendForm == false || phoneErr == true"
          >
            <div v-if="statusSendForm == false">
              Попробуйте отправить заявку позже
            </div>
            <div v-if="phoneErr == true">Введите номер телефона</div>
          </ErrorBlock>
          <ButtonSimple
            :text="'Отправить'"
            :styleText="{fontSize: '26px', margin: 0, opacity: 1}"
            @click="sendForm()"
          />
        </form>
        <span
          v-if="statusSendForm != true"
          :class="[style.politicalText, style.underHeader]"
          >НАЖИМАЯ НА КНОПКУ ВЫ ДАЁТЕ СОГЛАСИЕ НА ОБРАБОТКУ ПЕРСОНАЛЬНЫХ ДАННЫХ
          И СОГЛАШАЕТЕСЬ С
          <a target="_blank" href="/policy"
            >ПОЛИТИКОЙ КОНФИДЕНЦИАЛЬНСОТИ</a
          ></span
        >
      </div>
    </section>
    <footer :class="modile ? style.mobileFooter : ''">
      <div>
        <img src="$images/logo.svg" alt="" />
        <span
          >2023–2024 Readds ©<br />
          Все права защищены<br />
          <a target="_blank" href="/policy"
            >Политика конфиденциальности</a
          ></span
        >
      </div>
      <div>
        <article>
          <span>Техподдержка в Телеграме</span>
          <div>@readssheplmebot</div>
        </article>
        <article>
          <span>Техподдержка в почте</span>
          <div>info@readds.ru</div>
        </article>
      </div>
    </footer>
  </div>
</template>
<script lang="ts">
import {API} from "@/api/generated";
import style from "./StyleMain.module.scss";
import eye from "$images/eye.svg";
import {tariffList} from "@/datas/tarifs";
import ButtonComponent from "@/elements/buttonPurpleWhite/ButtonComponent.vue";
import ButtonSimple from "@/elements/buttonPurpleWhite/ButtonSimple.vue";
import {defineComponent} from "vue";
export default defineComponent({
  name: "mainComponents",
  components: {ButtonSimple, ButtonComponent},
  created() {
    // this.$router.push('/user')
    if (window.innerWidth < 770) {
      this.modile = true;
    }
  },
  data() {
    return {
      modile: false,
      style,
      eye,
      form: {
        name: "",
        city: "",
        clinic: "",
        phone: "",
        utm: ""
      },
      statusSendForm: null as boolean | null,
      phoneErr: false,
      tariffList
    };
  },
  methods: {
    wayToСonnectionForm() {
      window.location.href = "/#connectionForm";
    },
    setPhone(event: Event) {
      this.phoneErr = false;
      const target = event.target as HTMLInputElement;
      let number = target.value;
      if (number.slice(0, 2) != "+7") {
        number = "+7" + number;
      }
      const pattern = new RegExp(
        `(^\\d{${number.length % 11}})(\\d{3})(\\d{3})(\\d{2})(\\d{2}$)`
      );
      const formattedNumber = number
        .replace(pattern, "+$1 $2 $3-$4-$5")
        .slice(0, 16);
      this.form.phone = formattedNumber;
      target.value = formattedNumber;
    },
    async sendForm() {
      if (this.form.phone.length < 16) {
        this.phoneErr = true;
        return;
      }
      const search = location.search.substring(1);
      if (search != "") {
        const params = JSON.parse(
          '{"' +
            decodeURI(search)
              .replace(/"/g, '\\"')
              .replace(/&/g, '","')
              .replace(/=/g, '":"') +
            '"}'
        );
        let newParams = "";
        Object.entries(params).forEach((param) => {
          if (param[0].substring(0, 3).toLowerCase() == "utm") {
            newParams += param[0] + ": " + param[1] + "\n";
          }
        });
        this.form.utm = newParams;
      }
      await API.setMailDemonstration({body: this.form})
        .then(() => {
          this.form = {
            name: "",
            city: "",
            clinic: "",
            phone: "",
            utm: ""
          };
          this.statusSendForm = true;
        })
        .catch(() => {
          this.statusSendForm = false;
        });
    }
  }
});
</script>
